import { __awaiter, __generator, __read, __values } from "tslib";
/**
 * 组装和转换结果
 */
function dataConvert(result) {
    if (!result)
        return result;
    var columns = result.columns, values = result.values;
    return {
        fields: columns,
        rows: values.map(function (val) {
            return columns.reduce(function (prev, col, index) {
                prev[col] = val[index];
                return prev;
            }, {});
        }),
    };
}
function normalizeResult(res) {
    if (res === null || res === void 0 ? void 0 : res[0]) {
        var hydratedData = dataConvert(res[0]);
        return hydratedData;
    }
    // 空结果
    return {
        rows: [],
        fields: [],
    };
}
// SELECT users.id AS "users:id", ...
// => [ { users: { id, ... } } ]
function nest(rows, fields, spell) {
    var e_1, _a;
    var Model = spell.Model;
    var tableAlias = Model.tableAlias;
    var results = [];
    try {
        for (var rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
            var row = rows_1_1.value;
            var result = {};
            var qualified = Object.keys(row).some(function (entry) { return entry.includes(':'); });
            for (var key in row) {
                var parts = key.split(':');
                var _b = __read(qualified
                    ? (parts.length > 1 ? parts : ['', key])
                    : [Model.attributeMap.hasOwnProperty(key) ? tableAlias : '', key], 2), qualifier = _b[0], column = _b[1];
                var obj = result[qualifier] || (result[qualifier] = {});
                obj[column] = row[key];
            }
            results.push(result);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { rows: results, fields: fields };
}
function defaultInitSqlJs(options) {
    return __awaiter(this, void 0, void 0, function () {
        var initSqlJs, SQL, _a, data, database;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, import('sql.js')];
                case 1:
                    initSqlJs = (_b.sent()).default;
                    return [4 /*yield*/, initSqlJs()];
                case 2:
                    SQL = _b.sent();
                    _a = options.data, data = _a === void 0 ? null : _a;
                    database = new SQL.Database(data);
                    return [2 /*return*/, database];
            }
        });
    });
}
var SqljsConnection = /** @class */ (function () {
    function SqljsConnection(options) {
        this.options = options;
        this.database = undefined;
    }
    SqljsConnection.prototype.getConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, initSqlJs, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.database) {
                            return [2 /*return*/, this];
                        }
                        _a = this.options.initSqlJs, initSqlJs = _a === void 0 ? defaultInitSqlJs : _a;
                        // Create a database
                        _b = this;
                        return [4 /*yield*/, initSqlJs(this.options)];
                    case 1:
                        // Create a database
                        _b.database = _c.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    SqljsConnection.prototype.release = function () {
        // noop
    };
    SqljsConnection.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.database) {
                    console.warn('close: database is null');
                    return [2 /*return*/, true];
                }
                this.database = undefined;
                return [2 /*return*/];
            });
        });
    };
    SqljsConnection.prototype.query = function (query, values, spell) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, sql, nestTables, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = typeof query === 'string'
                            ? { sql: query, nestTables: false }
                            : query, sql = _a.sql, nestTables = _a.nestTables;
                        if (!/^(?:pragma|select)/i.test(sql)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._executeSQL(sql, values)];
                    case 1:
                        result = _b.sent();
                        if (nestTables)
                            return [2 /*return*/, nest(result.rows, result.fields, spell)];
                        return [2 /*return*/, result];
                    case 2: return [4 /*yield*/, this._runSQL(sql, values)];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    SqljsConnection.prototype._runSQL = function (query, values) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var affectedRows, lastInsertRowRet, lastId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.database) {
                            throw new Error('database not opened!');
                        }
                        this.database.run(query, values);
                        affectedRows = this.database.getRowsModified();
                        return [4 /*yield*/, this._executeSQL('SELECT last_insert_rowid() as lastId;')];
                    case 1:
                        lastInsertRowRet = _c.sent();
                        lastId = (_b = (_a = lastInsertRowRet === null || lastInsertRowRet === void 0 ? void 0 : lastInsertRowRet.rows) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.lastId;
                        return [2 /*return*/, {
                                insertId: lastId,
                                affectedRows: affectedRows,
                            }];
                }
            });
        });
    };
    SqljsConnection.prototype._executeSQL = function (query, values) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                if (!this.database) {
                    throw new Error('database not opened!');
                }
                res = this.database.exec(query, values);
                return [2 /*return*/, normalizeResult(res)];
            });
        });
    };
    return SqljsConnection;
}());
export { SqljsConnection };
//# sourceMappingURL=sqljs-connection.js.map